import React, { memo, useState, useEffect } from "react";
import CardTalent from "components/Cards/CardTalent";
import withDrawer from "utils/withDrawer";
import { getTalents } from "services/Talent";

const TalentList = (props) => {
  const [talentList, setTalentList] = useState(null);

  async function fetchTalents() {
    const result = await getTalents();

    setTalentList(result);
  }

  useEffect(() => {
    fetchTalents();
  }, []);

  return (
    <>
      <div className="pl-[16px]">
        <div className="flex flex-wrap m-[-4px] md:gap-y-[80px]">
          {talentList?.map((item, index) => (
            <div className="w-1/2 md:w-1/4" key={index}>
              <div className="w-full p-[4px]">
                <CardTalent
                  data={item}
                  openDrawer={props.openDrawer}
                  handleOpenDrawer={props.handleOpenDrawer}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default withDrawer(TalentList);
